import React, { PureComponent } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import truncate from 'lodash/truncate';
import css from './index.scss';
import { COMPONENT_ID, DEFAULT_VARIANT } from './constant';

class DropdownList extends PureComponent {
    render() {
        let index = 1;
        const keyAttr = !this.props.optionKey ? 'key' : this.props.optionKey;
        const stringAttr = !this.props.optionText ? 'value' : this.props.optionText;

        // Custom label generator that uses function to use current item's properties
        const { customLabelFn } = this.props;
        const customItemLabelGenerator = customLabelFn || (() => {});

        const listOptions = this.props.options ? this.props.options.map((option) => {
            let text = customLabelFn ? customItemLabelGenerator(option) : option[stringAttr];
            text = truncate(text, { length: this.props.optionLength > 0 ? this.props.optionLength : 40 });
            index += 1;
            const disabled = option.disabled ? { disabled: 'disabled' } : {};
            return <option {...disabled} key={`${option[keyAttr]}_${index}`} value={option[keyAttr]}>{text}</option>;
        }) : '';
        let placeholderText = '';

        if (this.props.isLoading) {
            placeholderText = this.props.loadingPlaceholder ? this.props.loadingPlaceholder : `${this.props.placeholder} ...`;
        } else {
            placeholderText = this.props.placeholder;
        }
        const placeholderOption = this.props.placeholder ? (
            <option key="-1" value="-1" > {placeholderText} </option>
        ) : '';

        const isDropdownDisabled = this.props.disabled ? { disabled: 'disabled' } : {};

        const containerClasses = [COMPONENT_ID, this.props.css[DEFAULT_VARIANT]];

        // Append variant styling
        const { variant } = this.props;
        if (css[variant]) {
            containerClasses.push(css[variant]);
        }

        // Dropdown Title
        const getTitle = () => {
            const valueToString = this.props.value.toString();
            const selectedOption = this.props.options.find(item => item.key === valueToString);
            if (selectedOption) return selectedOption.value;
            return '';
        };

        return (
            <div className={containerClasses.join(' ').trim()}>
                <select
                    {...isDropdownDisabled}
                    name={this.props.name}
                    title={getTitle()}
                    onChange={e => this.props.onChange(e.currentTarget.name, e.currentTarget.value)}
                    value={this.props.value}
                >
                    {placeholderOption}
                    {listOptions}
                </select>
            </div>
        );
    }
}

DropdownList.defaultProps = {
    options: [],
    value: ''
};

DropdownList.propTypes = {
    css: PropTypes.object,
    customLabelFn: PropTypes.func,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    loadingPlaceholder: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array.isRequired,
    optionLength: PropTypes.number,
    optionKey: PropTypes.string,
    optionText: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    variant: PropTypes.string
};

export default styleable(css)(DropdownList);




// WEBPACK FOOTER //
// ./app/components/dropdown-list/index.js